import React from 'react';
import propTypes from 'prop-types';

// components
import ValueWithHeader from 'common/ValueWithHeader';
import ValueWithUnit from 'common/ValueWithUnit';
import { Icon, TooltipWrapper } from '@tcc/crate';
import { cropIds } from 'constants/crops';

// util
import { bagText } from 'util/bagText';
import { getMessage } from 'util/locale';
import { formatNumSeedBags } from 'util/formatters/numberFormatter';
import { convertForLocale } from 'util/unitConversion';
import ScriptProductApplicationSummaryStats from 'edit/ScriptProductApplicationSummaryStats';
import { isEmeaCountry } from 'constants/countryCodes';

const baseString = 'vra-script-product-application-summary';
let ScriptSeedApplicationSummary = ({
  accountCountry,
  avgRate,
  bagSize,
  cropId,
  cropNominalWeight,
  numPopulatedZones,
  numSeedBags,
  numZones
}) => {
  let content = getMessage('placeholder-text__script-product-application-summary');
 
  if (numZones) {
    const convertedAvgRate = convertForLocale({
      quantity: avgRate.q,
      unit: avgRate.u,
      unitType: 'seed-density.seed-density-short',
      cropNominalWeight: cropNominalWeight
    });

    const isCorn = String(cropId) === String(cropIds.CORN);

    content = (
      <ScriptProductApplicationSummaryStats>
        <ValueWithHeader
          header={getMessage('title-text__avg-population--short')}
          value={(
            <ValueWithUnit
              unit={convertedAvgRate.symbol.quantitySpecific}
              value={convertedAvgRate.scalarLocaleString}
            />
          )}
        />
        <div className="vra-script-product-application-summary__content">
          <ValueWithHeader
            header={getMessage('title-text__seed-bags--short')}
            value={bagText(accountCountry, formatNumSeedBags(numSeedBags), cropId)}
          />
          {isCorn && isEmeaCountry(accountCountry) && <div className="vra-script-product-applicaiton-summary__tooltip">
            <TooltipWrapper
              content={[getMessage('text__script-seed-bag-info', {bagSize})]}
              placement='top'
            >
              <a>
                <Icon className='warning-icon' glyph={Icon.set.INFO_CIRCLE} />
              </a>
            </TooltipWrapper>
          </div>}
        </div>
      </ScriptProductApplicationSummaryStats>
    );
  }

  return (
    <section className={baseString} data-test-id="vra-script-seed-application-summary">
      <div className={`${baseString}__header-container`}>
        <header>{getMessage('title-text__script-creator--summary')}</header>
        {
          numZones > 0
            ? <span data-test-id='num-of-zones'>{getMessage('text__zone-summary__num-entered--num-and-zones',
              { numPopZones: numPopulatedZones, numZones: numZones })}
            </span> : null
        }
      </div>
      <div>
        {content}
      </div>
    </section>
  );
};

ScriptSeedApplicationSummary.propTypes = {
  accountCountry: propTypes.string.isRequired,
  avgRate: propTypes.shape({
    q: propTypes.number.isRequired,
    u: propTypes.string.isRequired
  }),
  bagSize: propTypes.number.isRequired,
  cropId: propTypes.number.isRequired,
  cropNominalWeight: propTypes.number.isRequired,
  numPopulatedZones: propTypes.number.isRequired,
  numSeedBags: propTypes.number.isRequired,
  numZones: propTypes.number.isRequired
};
export default ScriptSeedApplicationSummary;
